import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700" }




export default /*#__PURE__*/_defineComponent({
  __name: 'Progressbar',
  props: {
  barColor: String,
  percentage: String
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h-2.5 rounded-full",
      style: _normalizeStyle({background: props.barColor, width: props.percentage})
    }, null, 4)
  ]))
}
}

})